/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { Component, createRef, ElementRef } from 'react';
import { View, StyleSheet } from 'react-native';

import DataStore from '../../support/DataStore';
import LoadingIndicator from '../uiold/LoadingIndicator';
import { fetchData, postJSON } from '../../support/Fetch';
import {
  Alert,
  Button,
  Form,
  SubmitButton,
  Text,
  TextInputPassword,
} from '../uiold';
import { themeColors, basicColors } from '../uiold/Constants';

const dataStore = DataStore.getInstance('app');

type Props = {
  changePasswordData: { id: string; token: string };
  onSuccess: () => void;
  onBackToLogin: () => void;
};

type State = {
  isLoading: boolean;
  alertMessage?: string | null | undefined;
  alertMessageType: 'error' | 'success';
  accountType?: 'vendor' | 'market';
  redirectUrl?: string;
  isValid?: boolean;
  inputValue: {
    newPassword: string;
    repeatNewPassword: string;
  };
  isPasswordChangeSuccess: boolean;
  username?: string;
  pageTitle: string;
};

type TextInputInstance = ElementRef<typeof TextInputPassword>;

export default class PasswordResetForm extends Component<Props, State> {
  _inputRef = createRef<TextInputInstance>();

  state: State = {
    isLoading: true,
    inputValue: {
      newPassword: '',
      repeatNewPassword: '',
    },
    alertMessage: '',
    accountType: 'market',
    redirectUrl: '',
    alertMessageType: 'error' as const,
    isValid: false,
    username: '',
    isPasswordChangeSuccess: false,
    pageTitle: 'Change Password',
  };

  componentDidMount() {
    this._checkPasswordDataValidity(this.props.changePasswordData);
  }

  render() {
    let { onBackToLogin } = this.props;
    let {
      isLoading,
      isValid,
      isPasswordChangeSuccess,
      username,
      inputValue: { newPassword },
      pageTitle,
    } = this.state;

    let navigateTo = (url: string) => {
      // TODO: useNavigation()
      if (url.startsWith('/')) {
        history.replaceState({}, document.title, url);
      } else {
        location.replace(url);
      }
    };

    let content;
    if (isLoading) {
      content = <LoadingIndicator />;
    } else if (isPasswordChangeSuccess && username) {
      content = (
        <View style={styles.root}>
          <View style={[styles.mainView, { paddingBottom: 10, paddingTop: 0 }]}>
            {this._renderErrorAlert()}
            <Text type="label">
              Password Changed Successfully. Click button below to continue
            </Text>
          </View>
          <Button
            style={styles.backToLoginButton}
            title="Continue"
            textStyle={styles.backToLoginText}
            textHoverStyle={{ textDecorationLine: 'underline' } as any}
            onPress={() => {
              if (this.state.redirectUrl) {
                navigateTo(this.state.redirectUrl);
              } else {
                // TODO: Do the auth stuff directly after password reset, don't wait for user interaction.
                this._login(username, newPassword);
              }
            }}
          />
        </View>
      );
    } else if (isValid) {
      content = (
        <View style={styles.root}>
          <Form style={styles.mainView} onSubmit={this._onSubmit}>
            {this._renderErrorAlert()}
            <TextInputPassword
              autoFocus
              ref={this._inputRef}
              style={[styles.formControl, styles.formControlFocus]}
              placeholder="New Password"
              value={this.state.inputValue.newPassword}
              onChangeText={(value) => {
                let { inputValue } = this.state;
                this.setState({
                  inputValue: {
                    ...inputValue,
                    newPassword: value,
                  },
                });
              }}
            />
            <TextInputPassword
              containerStyle={{
                marginTop: 15,
              }}
              ref={this._inputRef}
              style={[styles.formControl, styles.formControlFocus]}
              placeholder="Repeat New Password"
              value={this.state.inputValue.repeatNewPassword}
              onChangeText={(value) => {
                let { inputValue } = this.state;
                this.setState({
                  inputValue: {
                    ...inputValue,
                    repeatNewPassword: value,
                  },
                });
              }}
            />
            <SubmitButton
              style={styles.saveNewPasswordButton}
              hoverStyle={styles.active}
              title="Save New Password"
              textStyle={[styles.saveNewPasswordText]}
              isDisabled={this._isButtonSubmitDisabled()}
            />
          </Form>
          <Button
            style={styles.backToLoginButton}
            title="Back to Login"
            onPress={() => {
              if (
                this.state.accountType === 'vendor' &&
                this.state.redirectUrl
              ) {
                navigateTo(this.state.redirectUrl);
              } else {
                onBackToLogin();
              }
            }}
            titleType="label"
            textStyle={styles.backToLoginText}
            textHoverStyle={{ textDecorationLine: 'underline' } as any}
          />
        </View>
      );
    } else if (isValid === false) {
      content = (
        <Button
          style={styles.backToLoginButton}
          title="Back to Login"
          titleType="label"
          textStyle={styles.backToLoginText}
          textHoverStyle={{ textDecorationLine: 'underline' } as any}
          onPress={onBackToLogin}
        />
      );
    }

    return (
      <View style={styles.root}>
        <Text style={styles.changePasswordTitle}>{pageTitle}</Text>
        {content}
      </View>
    );
  }

  _isButtonSubmitDisabled = () => {
    let { newPassword, repeatNewPassword } = this.state.inputValue;
    return !(newPassword && repeatNewPassword);
  };

  _checkPasswordDataValidity = (changePasswordData: {
    token: string;
    id: string;
  }) => {
    let { token, id } = changePasswordData;
    fetchData(
      // TODO: Change this endpoint.
      `/api/users/${id}/password/reset/${token}`,
      { method: 'GET' },
      (error, data) => {
        if (error) {
          this.setState({
            isLoading: false,
            alertMessage: error.message,
            alertMessageType: 'error',
            isValid: false,
          });
          return;
        }
        if (data.success) {
          this.setState({
            isLoading: false,
            isValid: true,
            redirectUrl: data?.redirectUrl ?? '',
            accountType: data?.accountType === 'vendor' ? 'vendor' : 'market',
          });
          return;
        }
      },
    );
  };

  _renderErrorAlert = () => {
    let { alertMessage, alertMessageType } = this.state;
    if (!alertMessage) {
      return;
    }
    return (
      <Alert
        style={{ marginBottom: 10, width: '100%' }}
        type={alertMessageType}
        text={alertMessage}
        onDismiss={this._errorDismiss}
        allowResize
      />
    );
  };

  _onSubmit = () => {
    if (this._isButtonSubmitDisabled()) {
      return;
    }
    this._errorDismiss();
    let errorText = '';
    let { newPassword, repeatNewPassword } = this.state.inputValue;
    let passwordOne = newPassword;
    let passwordTwo = repeatNewPassword;
    if (passwordOne.length === 0) {
      errorText = 'Please enter a password.';
    } else if (passwordOne !== passwordTwo) {
      errorText = 'Passwords do not match.';
    }
    if (errorText) {
      this.setState(
        { alertMessage: errorText, alertMessageType: 'error' },
        () => {
          setTimeout(() => {
            let instance = this._inputRef.current;
            instance && instance.focus();
          }, 500);
        },
      );
      return;
    }
    let {
      changePasswordData: { id, token },
    } = this.props;
    this.setState({ isLoading: true });

    postJSON(
      // TODO: Change this endpoint.
      `/api/users/${id}/password/reset/${token}`,
      { password: passwordOne },
      (error, data) => {
        if (error) {
          this.setState({
            isLoading: false,
            alertMessage: error.message,
            alertMessageType: 'error',
          });
        } else if (!data.success) {
          this.setState({
            isLoading: false,
            alertMessage: data.errorMessage,
            alertMessageType: 'error',
          });
        } else {
          this.setState({
            isLoading: false,
            isPasswordChangeSuccess: true,
            redirectUrl:
              typeof data.redirectUrl === 'string' ? data.redirectUrl : '',
            username: data.username,
            pageTitle: 'Success',
          });
          this.props.onSuccess();
        }
      },
    );
  };

  _login = (username: string | null | undefined, password: string) => {
    if (username) {
      let reqData = {
        username,
        password,
      };
      this.setState({ isLoading: true });
      postJSON('/api/auth', reqData, (error, data) => {
        this.setState({ isLoading: false });
        if (error) {
          this.setState({
            alertMessage: error.message,
            alertMessageType: 'error',
          });
        } else if (data.success) {
          dataStore.set('user', data.user);
          dataStore.set('account', {
            ...data.account,
            token: data.token,
            system_admin: data.system_admin,
          });
        } else {
          this.setState({
            alertMessage: 'Failed to login',
            alertMessageType: 'error',
          });
        }
      });
    }
  };

  _errorDismiss = () => {
    this.setState({ alertMessage: null });
  };
}

let styles = StyleSheet.create({
  root: {
    flex: 1,
  },
  mainView: {
    paddingHorizontal: 30,
    paddingTop: 10,
    flex: 1,
  },
  active: {
    backgroundColor: themeColors.greenButtonHovered,
    borderColor: themeColors.buttonHoveredBorder,
  },
  backToLoginButton: {
    marginHorizontal: 0,
    backgroundColor: themeColors.buttonGrey,
    width: '100%',
    borderBottomLeftRadius: 7,
    borderBottomRightRadius: 7,
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
    height: 58,
    borderWidth: 0,
  },
  formControl: {
    backgroundColor: themeColors.textInputBackground,
    height: 43,
    color: themeColors.textInputText,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: themeColors.textInputBorder,
  },
  changePasswordTitle: {
    textAlign: 'center',
    color: themeColors.formTitle,
    fontWeight: '300',
    fontSize: 28,
    marginBottom: 20,
    marginTop: 20,
  },
  backToLoginText: {
    fontWeight: '600',
    color: themeColors.greyButtonText,
    paddingVertical: 20,
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  saveNewPasswordButton: {
    marginHorizontal: 0,
    paddingVertical: 10,
    paddingHorizontal: 30,
    marginTop: 15,
    marginBottom: 25,
    backgroundColor: themeColors.formButtonBackground,
    borderColor: themeColors.formButtonBorder,
    borderRadius: 3,
    width: '100%',
  },
  saveNewPasswordText: {
    textAlign: 'center',
    fontWeight: '600',
    textTransform: 'uppercase',
    color: basicColors.white,
    marginHorizontal: 0,
  },
  formControlFocus: {},
});
